export const QUOTE_REQUEST_CACHE_KEY = 'deroyalty.quoteRequest.lastSubmission';
export const QUOTE_DUPLICATE_WINDOW_MS = 24 * 60 * 60 * 1000;

function normalizeValue(value) {
  return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
}

export function buildQuoteMessage({
  message = '',
  requestSource = 'Website quote request',
  vehicleName = '',
} = {}) {
  const parts = [
    `Request type: ${requestSource}`,
    vehicleName ? `Vehicle: ${vehicleName}` : '',
    'Message:',
    message.trim(),
  ].filter(Boolean);

  return parts.join('\n');
}

export function getQuoteFingerprint(payload = {}) {
  return [
    normalizeValue(payload.name),
    normalizeValue(payload.email),
    normalizeValue(payload.phone),
    normalizeValue(payload.city),
    normalizeValue(payload.country),
    normalizeValue(payload.message),
  ].join('|');
}

function getStorage(storage) {
  if (storage) return storage;
  if (typeof window === 'undefined') return null;
  return window.localStorage;
}

export function isDuplicateQuoteRequest(payload, storage, now = Date.now()) {
  const storageTarget = getStorage(storage);
  if (!storageTarget) return false;

  try {
    const rawRequest = storageTarget.getItem(QUOTE_REQUEST_CACHE_KEY);
    if (!rawRequest) return false;

    const lastRequest = JSON.parse(rawRequest);
    const isSameRequest = lastRequest.fingerprint === getQuoteFingerprint(payload);
    const isInsideWindow = now - Number(lastRequest.submittedAt || 0) < QUOTE_DUPLICATE_WINDOW_MS;

    return Boolean(isSameRequest && isInsideWindow);
  } catch (error) {
    return false;
  }
}

export function rememberQuoteRequest(payload, storage, now = Date.now()) {
  const storageTarget = getStorage(storage);
  if (!storageTarget) return;

  try {
    storageTarget.setItem(
      QUOTE_REQUEST_CACHE_KEY,
      JSON.stringify({
        fingerprint: getQuoteFingerprint(payload),
        submittedAt: now,
      })
    );
  } catch (error) {
    // Quotation duplicate protection is progressive enhancement only.
  }
}
